import React from "react"
import WordpressHostingBlock from "../hosting/WordpressHostingBlock"

const WordpressBlock = () => {
  return (
    <section className="pricing text-start">
      <div className="container-xl">
        <h3 className="mb-4 component-title text-dark-blue">
          Unleash the Power of Reliable WordPress Hosting
        </h3>
        <div className="row">
          <WordpressHostingBlock />
          <div className="col-12 col-lg-8">
            <div className="description">
              <p>
                <strong>Lightning-Fast Speed: </strong>
                Speed is paramount in today's digital landscape. Studies show
                that users expect websites to load in just a few seconds, or
                they'll move on. With Motherhost, your website will blaze
                through cyberspace, thanks to our cutting-edge infrastructure
                and optimized servers. Experience lightning-fast loading times
                that keep your visitors engaged and coming back for more.
              </p>

              <p>
                <strong>Unrivaled Uptime: </strong>
                Downtime can be disastrous for your online presence, leading to
                lost revenue and frustrated visitors. Motherhost ensures
                unparalleled uptime, with a rock-solid infrastructure designed
                to keep your website online 24/7. Our redundant systems and
                proactive monitoring mean you can rest easy, knowing that your
                site is always accessible to your audience.
              </p>

              <p>
                <strong>Robust Security: </strong>
                In an era of increasing cyber threats, protecting your website
                is non-negotiable. Motherhost takes security seriously,
                employing multiple layers of defense to safeguard your valuable
                data. From automatic backups and malware scanning to SSL
                encryption and firewalls, we've got you covered. Focus on
                growing your business while we handle the security of your
                WordPress website.
              </p>

              <p>
                <strong>Seamless Scalability: </strong>
                As your website grows, so do your hosting needs. Motherhost
                offers seamless scalability, allowing you to effortlessly
                upgrade your resources as your traffic expands. Whether you're
                launching a new blog or running a bustling e-commerce store, our
                flexible hosting plans can accommodate your evolving
                requirements without missing a beat.
              </p>

              <p>
                <strong>Expert Support: </strong>
                Need a helping hand? Our team of WordPress experts is here for
                you every step of the way. Whether you have questions, encounter
                technical issues, or need advice on optimizing your website, our
                friendly support staff is just a click or call away. With
                Motherhost, you're not just a customer; you're part of our
                family.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WordpressBlock
